<template>
  <div class="home">
    <div class="banner">
      <div>
        <div>构建万物互联的智能工厂</div>
        <div @click="toCompany">查看更多</div>
      </div>
    </div>
    <div class="introduce">
      <h2 class="title">{{ $t("home.who") }}</h2>
      <div class="history">
        <img src="../../assets/image/home/history.png" alt=""/>
        <div class="text">
          <p>{{ $t("home.about") }}</p>
          <p>{{ $t("home.about2") }}</p>
        </div>
      </div>
      <div class="adv">
        <img alt="" src="../../assets/image/home/total/1.png"/>
        <img alt="" src="../../assets/image/home/total/2.png"/>
        <img alt="" src="../../assets/image/home/total/3.png"/>
        <img alt="" src="../../assets/image/home/total/4.png"/>
      </div>
    </div>
    <div class="industry">
      <h2 class="title">{{ $t("home.industry") }}</h2>
      <div class="system-list">
        <div>
          <div class="system">
            <img src="../../assets/image/home/wms.svg" alt=""/>
          </div>
          <h3>{{ $t("home.wms") }}</h3>
          <span>{{ $t("home.wms_system") }}</span>
        </div>
        <div>
          <div class="system">
            <img src="../../assets/image/home/mes.svg" alt=""/>
          </div>
          <h3>{{ $t("home.mes") }}</h3>
          <span>{{ $t("home.mes_system") }}</span>
        </div>
        <div>
          <div class="system">
            <img src="../../assets/image/home/npm.svg" alt=""/>
          </div>
          <h3>{{ $t("home.npm") }}</h3>
          <span>{{ $t("home.npm_system") }}</span>
        </div>
        <div>
          <div class="system">
            <img src="../../assets/image/home/iiot.svg" alt=""/>
          </div>
          <h3>{{ $t("home.iiot") }}</h3>
          <span>{{ $t("home.iiot_system") }}</span>
        </div>
        <div>
          <div class="system">
            <img src="../../assets/image/home/npi.svg" alt=""/>
          </div>
          <h3>{{ $t("home.npi") }}</h3>
          <span>{{ $t("home.npi_system") }}</span>
        </div>
      </div>
    </div>
    <!-- 为什么选择我们 -->
    <div class="choose">
      <h2 class="title">为什么要选择我们</h2>
      <whyChooseUs></whyChooseUs>
      <!--
      <div class="choose-carousel-box">
        <el-carousel ref="carousel" type="card" arrow="never" :autoplay="true">
          <div class="carousel" v-for="(i, index) in chooseData" :key="index">
            <el-carousel-item>
              <div class="choose-content">
                <div class="top">
                  <img :src="i.url"/>
                  <h3>{{ i.name }}</h3>
                  <p>{{ i.text }}</p>
                </div>
                <i class="el-icon-right"></i>
              </div>
            </el-carousel-item>
          </div>
        </el-carousel>
        <div class="left-right">
          <img
              @click="leftClick"
              width="30"
              height="30"
              src="../../assets/image/home/lunbo/left.svg"
          />
          <img
              @click="rightClick"
              width="30"
              height="30"
              src="../../assets/image/home/lunbo/right.svg"
          />
        </div>
      </div>
      -->
    </div>
    <!-- 案列 -->
    <div class="share">
      <h2 class="title">给您分享几个案列</h2>
      <myCase></myCase>
      <!--
      <div class="lunbo">
        <swiper ref="mySwiper" :options="swiperOptions" style="height: 420px">
          <swiper-slide style="display: flex">
            <div class="haoen">
              <div class="c-box">
                <img src="../../assets/image/home/lunbo/haoen.png" alt=""/>
                <div class="name">豪恩集团</div>
                <span>为客户提供智能产品全方位解决方案的科技集团公司</span>
              </div>
              <div class="c-box">
                <img src="../../assets/image/home/lunbo/suteng.png" alt=""/>
                <div class="name">速腾聚创</div>
                <span>为客户提供智能产品全方位解决方案的科技集团公司</span>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide style="display: flex">
            <div class="haoen">
              <div class="c-box">
                <img src="../../assets/image/home/lunbo/huayang.png" alt=""/>
                <div class="name">华阳通用</div>
                <span>为客户提供智能产品全方位解决方案的科技集团公司</span>
              </div>
              <div class="c-box">
                <img src="../../assets/image/home/lunbo/suteng.png" alt=""/>
                <div class="name">速腾聚创</div>
                <span>为客户提供智能产品全方位解决方案的科技集团公司</span>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide style="display: flex">
            <div class="haoen">
              <div class="c-box">
                <img src="../../assets/image/home/lunbo/haoen.png" alt=""/>
                <div class="name">豪恩集团</div>
                <span>为客户提供智能产品全方位解决方案的科技集团公司</span>
              </div>
              <div class="c-box">
                <img src="../../assets/image/home/lunbo/suteng.png" alt=""/>
                <div class="name">速腾聚创</div>
                <span>为客户提供智能产品全方位解决方案的科技集团公司</span>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide style="display: flex">
            <div class="haoen">
              <div class="c-box">
                <img src="../../assets/image/home/lunbo/huayang.png" alt=""/>
                <div class="name">华阳通用</div>
                <span>为客户提供智能产品全方位解决方案的科技集团公司</span>
              </div>
              <div class="c-box">
                <img src="../../assets/image/home/lunbo/haoen.png" alt=""/>
                <div class="name">豪恩集团</div>
                <span>为客户提供智能产品全方位解决方案的科技集团公司</span>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      -->
    </div>
    <!-- 合作伙伴 -->
    <div class="partners">
      <h2 class="title">合作伙伴</h2>
      <myPartners></myPartners>
      <!--
      <div class="partners-carousel-box">
        <el-carousel :interval="4000" :autoplay="true">
          <el-carousel-item v-for="(i, index) in cooperation" :key="index">
            <div class="partners-img">
              <img
                  width="120"
                  height="60"
                  v-for="(item, ind) in i"
                  :key="ind"
                  :src="item.url"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      -->
    </div>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import "swiper/swiper.scss";
import whyChooseUs from "@/components/carousel/whyChooseUs";
import myCase from "@/components/carousel/myCase";
import myPartners from "@/components/carousel/myPartners";

export default {
  data() {
    return {
      chooseData: [
        {
          url: "",
          name: "聚焦",
          text: "专注电子领域（PCB/PCBA）",
        },
        {
          url: "",
          name: "全面",
          text: "产品覆盖设计到制造全流程，让设计更懂制造，制造更懂设计",
        },
        {
          url: "",
          name: "落地",
          text: "深耕工业物联9年，可以自主完成大于100种设备的数据采集，不用再担心上系统踩到数据采集的坑，导致项目烂尾",
        },
        {
          url: "",
          name: "系统",
          text: "满足未来的BS+微服务集群架构，开源的物联平台",
        },
      ],
      cooperation: [], // 合作伙伴
      swiperOptions: {
        roundLengths: true,
        slidesPerView: "3",
        centeredSlides: true,
        spaceBetween: 20,
        // slidesOffsetBefore: -215,
        loop: true,
        speed: 1500,
        grabCursor: true,
        autoplay: {
          delay: 2500,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        mousewheel: false,
      },
    };
  },
  created() {
    for (let i = 1; i < 5; i++) {
      this.chooseData[i - 1].url = require("../../assets/image/home/lunbo/" +
          i +
          ".png");
    }
    var arr1 = [];
    var arr2 = [];
    var arr3 = [];
    var arr4 = [];
    for (let i = 1; i < 47; i++) {
      if (i < 15) {
        arr1.push({
          url: require("../../assets/image/home/partners/partners" +
              i +
              ".svg"),
        });
        this.cooperation[0] = arr1;
      } else if (i < 29) {
        arr2.push({
          url: require("../../assets/image/home/partners/partners" +
              i +
              ".svg"),
        });
        this.cooperation[1] = arr2;
      } else if (i < 43) {
        arr3.push({
          url: require("../../assets/image/home/partners/partners" +
              i +
              ".svg"),
        });
        this.cooperation[2] = arr3;
      } else {
        arr4.push({
          url: require("../../assets/image/home/partners/partners" +
              i +
              ".svg"),
        });
        this.cooperation[3] = arr4;
      }
    }
    console.log(this.cooperation);
  },
  mounted() {
    var mySwiper = new Swiper(".swiper", {
      autoplay: true, //可选选项，自动滑动
    });
    setTimeout(function () {
      // [0].getElementsByClassName('.lunbo')
      var obj = document.querySelector("div.swiper-slide-prev");
      var leftObj = $(".swiper-slide-active").prevAll();
      var w = $(".swiper-slide-active").width();
      var left = $(".lunbo .swiper-wrapper")
          .css("transform")
          .replace(/[^0-9\-,]/g, "")
          .split(",");
      var ml =
          $(".swiper-slide-active").prevAll().eq(1).width() * leftObj.length;
      var l = (ml + Number(left[4]) - w) / 2 + 40;
      obj.style.marginLeft = l + "px";
    }, 1000);
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    toCompany() {
      this.$router.push("/company");
    },
    leftClick() {
      this.$refs.carousel.prev();
    },
    rightClick() {
      this.$refs.carousel.next();
    },
  },
  components: {
    Swiper,
    SwiperSlide,
    whyChooseUs,
    myCase,
    myPartners
  },
};
</script>

<style scoped>
.home {
  padding-top: 80px;
  width: 100%;
}

.banner {
  width: 100%;
  height: 600px;
  background: url(../../assets/image/home/banner.png) center / cover no-repeat;
  margin-bottom: 50px;
}

.banner > div {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.banner > div > div:first-child {
  font-size: 50px;
  font-weight: bold;
  color: white;
  margin: 10px 0;
  text-align: center;
}

.banner > div > div:last-child {
  width: 130px;
  height: 50px;
  background: red;
  color: white;
  border-radius: 30px;
  font-size: 12px;
  padding: 0 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.banner > div > div:last-child:after {
  content: '';
  width: 20px;
  height: 20px;
  display: block;
  background: url(../../assets/image/home/goto.png) center / 15px no-repeat;
}

.introduce {
  background-image: url("../../assets/image/line.png");
  background-size: 100% 100%;
  font-size: 14px;
  color: #121212;
  line-height: 36px;
  z-index: 1;
}

.history {
  margin: 50px 180px;
  display: flex;
  justify-content: center;
}

.history > img {
  width: 180px;
  height: 180px;
  margin-right: 150px;
}

.adv {
  width: 100%;
  height: 150px;
  background: url(../../assets/image/home/adv.png) center / cover no-repeat;
  display: flex;
  padding: 35px 60px;
  box-sizing: border-box;
}

.adc img {
  height: 100%;
}

.text {
  margin-top: 20px;
}

.introduce > img {
  width: 100%;
  height: 190px;
  opacity: 0.8;
}

.industry {
  text-align: center;
  margin: 60px 0;
}

.system-list {
  margin-left: 140px;
  margin-right: 140px;
  margin-top: 40px;
  display: flex;
}

.system > span {
  text-align: center;
}

.system-list > div {
  width: 220px;
  font-size: 12px;
  color: #7e7e7c;
  line-height: 16px;
}

.system-list > div > h3 {
  font-size: 16px;
  color: #121212;
  margin-bottom: 20px;
}

.system {
  width: 220px;
  height: 160px;
  margin-bottom: 20px;
  background-color: #fafafa;
  position: relative;
  border-radius: 8px;
}

.system img {
  width: 110px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 180ms linear;
}

.system img:hover {
  width: 150px;
}

.choose,
.share,
.partners {
  margin-bottom: 80px;
}

/* 为什么选择我们 */
.choose-carousel-box {
  width: 100%;
  height: 430px;
  margin-top: 30px;
  position: relative;
}

.top > p {
  margin: 10px 50px;
  /* text-align: center; */
}

.choose-carousel-box .left-right {
  width: 85px;
  position: absolute;
  bottom: 25px;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
}

.choose-carousel-box .left-right img {
  cursor: pointer;
}

.choose-carousel-box ::v-deep .el-carousel__indicators--outside {
  display: none;
}

.choose-carousel-box ::v-deep .el-carousel__container,
.choose-carousel-box ::v-deep .el-carousel {
  height: 100%;
}

.choose-carousel-box ::v-deep .el-carousel__item--card.is-active {
  height: 350px;
}

.choose-carousel-box ::v-deep .el-carousel__item--card {
  height: 460px;
}

.choose-carousel-box .el-carousel__item--card.is-active .choose-content {
  width: 300px;
}

.choose {
  width: 100%;
  height: 100%;
}

.choose .choose-content {
  width: 350px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background-color: #ebeef5;
  border-radius: 8px;
}

.choose .choose-content img {
  width: 100px;
  height: 100px;
  border-radius: 100px;
  margin-bottom: 20px;
}

.choose .top {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.choose .choose-content p {
  font-size: 13px;
  color: #909399;
}

/* 案列轮播 */
.lunbo {
  margin-top: 40px;
  width: 100%;
  text-align: center;
  font-weight: 700;
  font-size: 20px;
  color: #000;
}

.name {
  margin-top: 30px;
  margin-bottom: 10px;
}

.lunbo span {
  font-size: 12px;
  color: #7e7e7c;
  line-height: 16px;
}

.lunbo ::v-deep .el-carousel__item {
  width: 840px;
  background-color: #ffffff;
}

/* .lunbo ::v-deep .swiper-slide-prev{
	margin-left: -8%;
} */

.lunbo ::v-deep .swiper-slide {
  /* width: 620px !important; */
  overflow: hidden;
}

.lunbo .swiper-slide img {
  width: 390px;
  height: 200px;
}

.lunbo .swiper-slide .c-box:last-child {
  /* margin-left: 15px; */
  display: none;
}

.lunbo ::v-deep .swiper-slide-active {
  width: 920px !important;
}

.lunbo .swiper-slide-active img {
  width: 450px !important;
  height: 250px !important;
}

.lunbo .swiper-slide-active .c-box:last-child {
  /* margin-left: 15px; */
  display: block;
}

/* .haoen,
.huayang,
.huarong.suteng {
	padding: 0 30px;
} */

.haoen {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* .c-box{
	width: 50%;
} */

/* 合作伙伴 */
.partners-carousel-box {
  height: 150px;
  margin-top: 20px;
}

.partners-carousel-box ::v-deep .el-carousel,
.partners-carousel-box ::v-deep .el-carousel__container {
  height: 100%;
}

.partners-carousel-box ::v-deep .el-carousel__indicators--outside {
  display: none;
}

.partners-img {
  width: 1000px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-content: flex-start;
}

.partners-img img {
  margin: 0 0 10px 10px;
  align-self: flex-start;
}

/* 标题 */
.title {
  text-align: center;
  font-size: 20px;
  color: #121212;
  line-height: 45px;
  position: relative;
}

h2:after {
  content: "";
  position: absolute;
  left: 49%;
  bottom: 0;
  height: 3px;
  width: 30px;
  background-color: red;
}
</style>
